function Menu_set_edit(element) {
	this.$element = $(element);
	this.popup = i4_Popup.get(this.$element);

	this.selectors = {

	};

	this.dataSelectors = {
		menuSetId: 'menu-set-id',
		languageId: 'language-id',
		imageDelete: 'image-delete',
		imageMove: 'image-move'
	};

	this.data = {
		menuSetId: 0,
		languageId: 0,
		imageDelete: '',
		imageMove: ''
	};

	this.init = function() {
		// console.log('Menu_set_edit - init()');
		this.data.menuSetId = this.$element.data(this.dataSelectors.menuSetId);
		this.data.languageId = this.$element.data(this.dataSelectors.languageId);
		this.data.imageDelete = this.$element.data(this.dataSelectors.imageDelete);
		this.data.imageMove = this.$element.data(this.dataSelectors.imageMove);
		this.initListEditor();
	};

	this.initListEditor = function() {
		i4_List_editor.get('list_menu_elements_result_' + this.data.languageId).
		set_element_result_id('list_menu_elements_result_' + this.data.languageId).
		set_ajax_parameter({
			js: 'menu',
			call: 'menu_set_list',
			menu_set_id: this.data.menuSetId,
			language_id: this.data.languageId
		}).
		set_option({
			image_delete: this.data.imageDelete,
			image_move: this.data.imageMove,
			after_delete_item: (function(menuSetElementId) {
				this.popup.set_layout().renew_position();

				// delete item via ajax to avoid deleting and re-inserting all items on save operation
				var parameter = $.extend({
					js: 'menu',
					menu_set_element_id: menuSetElementId,
					call: 'menu_set_element_delete'
				}, {});

				i4_Ajax.factory()
					.set_parameter(jQuery.param(parameter))
					.run()
				;

			}).bind(this),

      // once the form to insert new menu set element is ready
			after_add_item: (function() {
				this.popup.set_layout().renew_position();

				const new_type_links = this.$element.find('.c-menu-admin--new-choose a');
				$.each(new_type_links, function (index, new_type_link) {
				  const $link = $(new_type_link);
          $link.on('click', function () {
            $link.closest('.c-menu-admin--new').find('.c-menu-admin--new-'+$link.data('type')).first().show();
            $link.closest('.c-menu-admin--new-choose').hide();
          });
        });

			}).bind(this),

      // once the list of existing menu set elements is loaded
			after_load: (function() {
				this.popup.set_layout().renew_position();
			}).bind(this)
		}).
		run();
	};
}
